import { IconProps } from "../../utils/global-types/global-types";

const TrashIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M15.047 4.487a74 74 0 0 0-3.227-.247v-.007l-.147-.866c-.1-.614-.246-1.534-1.806-1.534H8.12c-1.553 0-1.7.88-1.807 1.527l-.14.853c-.62.04-1.24.08-1.86.14l-1.36.134a.5.5 0 0 0-.453.546.497.497 0 0 0 .547.447l1.36-.133C7.9 5 11.42 5.133 14.953 5.487h.054a.505.505 0 0 0 .5-.454.51.51 0 0 0-.46-.546M13.82 6.427a.84.84 0 0 0-.607-.26H4.787a.83.83 0 0 0-.834.886l.414 6.84c.073 1.014.166 2.28 2.493 2.28h4.28c2.327 0 2.42-1.26 2.493-2.28l.414-6.833a.86.86 0 0 0-.227-.633m-3.713 6.406h-2.22a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h2.22c.273 0 .5.227.5.5 0 .274-.227.5-.5.5m.56-2.666H7.333a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h3.334c.273 0 .5.226.5.5 0 .273-.227.5-.5.5"
      ></path>
    </svg>
  );
};

export default TrashIcon;
